import React from 'react';
import PropTypes from 'prop-types';
import NukaCarousel from 'nuka-carousel';
import { Pagination, CarouselPrev, CarouselNext } from './Controls';

// Wrapper for setting default carousel values to reduce duplication
export function Carousel(props) {
  const { showMobileControls, showDesktopControlsTop, showDesktopControlsCenter, ...nukaCarouselProps } = props;

  const controlsProps = {
    // nullify default nuka carousel controls
    renderCenterLeftControls: null,
    renderCenterRightControls: null,
    renderBottomCenterControls: null,

    // our custom controls
    ...(showMobileControls && {
      renderBottomCenterControls: Pagination,
    }),
    ...(showDesktopControlsTop && {
      renderTopLeftControls: CarouselPrev,
      renderTopRightControls: CarouselNext,
    }),
    ...(showDesktopControlsCenter && {
      renderCenterLeftControls: CarouselPrev,
      renderCenterRightControls: CarouselNext,
    }),
  };

  return <NukaCarousel {...controlsProps} {...nukaCarouselProps} />;
}

Carousel.propTypes = {
  showMobileControls: PropTypes.bool,
  showDesktopControlsTop: PropTypes.bool,
  showDesktopControlsCenter: PropTypes.bool,
};
